<template>
  <div>
    <Row>
      <Col span="12">
        <Form ref="form" :model="forms" :rules="formRules" :label-width="120">
          <form-header name="基本信息" :label="stitle ? stitle : '权限规则基本信息'"></form-header>
          <FormItem label="父级ID" prop="parentId">
            <!-- v-if="pid ? false : true" -->
            <Cascader :data="rule_arr" v-model="pids" change-on-select @on-change="this.pidChange"></Cascader>
          </FormItem>
          <FormItem label="规则名称" prop="menuName">
            <Input v-model="forms.menuName" placeholder="唯一规则名称" style="width:200px"></Input>
          </FormItem>
          <FormItem label="菜单类型" prop="menuType" v-if="parentId ? false : true">
            <Select v-model="forms.menuType" style="width:100px">
              <Option v-for="item in menuList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <!-- <FormItem :label="!forms.is_fast ? '单一路由' : '快捷路由'" prop="is_fast" v-if="pid ? false : true">
            <i-switch v-model="forms.is_fast" :true-value="1" :false-value="0"></i-switch>
          </FormItem> -->
          <!-- <FormItem label="路由" prop="path" v-if="!forms.is_fast">
            <Input v-model="forms.path" placeholder="请输入完整路由,结尾不能留/"></Input>
          </FormItem>
          <FormItem label="权限字符" prop="perms" v-if="!forms.is_fast">
            <Input v-model="forms.perms" placeholder="请输入权限字符,结尾不能留/"></Input>
          </FormItem> -->
          <FormItem label="组件路径" prop="component" v-if="!forms.is_fast&(forms.menuType=='M'||forms.menuType == 'C')">
            <Input v-model="forms.component" placeholder="请输入组件路径,结尾不能留/"></Input>
          </FormItem>
          <FormItem label="按钮路径" prop="perms" v-if="!forms.is_fast&(forms.menuType == 'F')">
            <Input v-model="forms.perms" placeholder="请输入按钮路径,结尾不能留/"></Input>
          </FormItem>
          <!-- <FormItem label="路由参数" prop="query" v-if="forms.is_fast">
            <Input v-model="forms.query" placeholder="请输入路由参数"></Input>
          </FormItem> -->
          <FormItem label="" v-if="forms.is_fast">
            <CheckboxGroup v-model="forms.methods">
              <Checkbox :label="'add'">新增</Checkbox>
              <Checkbox :label="'edit'">编辑</Checkbox>
              <Checkbox :label="'del'">删除</Checkbox>
              <Checkbox :label="'get'">查询</Checkbox>
              <Checkbox :label="'lists'">列表</Checkbox>
              <Checkbox :label="'pass'">审核</Checkbox>
              <Checkbox :label="'sync'">同步</Checkbox>
              <Checkbox :label="'import'">导入</Checkbox>
              <Checkbox :label="'export'">导出</Checkbox>
              <!-- 切换状态等 -->
              <Checkbox :label="'switch'">切换状态</Checkbox>
              <!-- 修改字段值 -->
              <Checkbox :label="'field'">修改字段</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <!-- <FormItem label="限制" prop="condition">
            <Input v-model="forms.condition" placeholder="请输入限制规则[可空]"></Input>
          </FormItem> -->
          <FormItem label="排序" prop="orderNum">
            <InputNumber v-model="forms.orderNum" placeholder="小值靠前"></InputNumber>
          </FormItem>
          <FormItem label="菜单状态">
            <i-switch v-model="forms.status" :trueValue="0" :falseValue="1"> </i-switch>
          </FormItem>
          <FormItem label="显示状态">
            <i-switch v-model="forms.visible" :trueValue="0" :falseValue="1"> </i-switch>
          </FormItem>
          <FormItem label="备注"  prop="remark">
            <Input v-model="forms.remark" type="textarea" :autosize="{ minRows: 5 }" placeholder="请输入备注[可空]"></Input>
          </FormItem>
          <button-box>
            <button-sub @click="handleSubmit" :loading="sloading"></button-sub>
            <button-back></button-back>
          </button-box>
        </Form>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      sloading: false,
      action: 'add',
      mname: 'menu',
      url: {},
      kv: '',
      rule_arr: [],
      parentId: '',
      pids: [],
      forms: {
        parentId: null,
        is_fast: 0, // 快捷路由用于快速设置权限规则
        status: 0,
        orderNum: 50,
      },
      menuList: [
        {
          value: 'M',
          label: '目录',
        },
        {
          value: 'C',
          label: '菜单',
        },
        {
          value: 'F',
          label: '按钮',
        },
      ],
    }
  },
  computed: {
    formRules() {
      let formRules = {
        parentId: [{ required: true, message: '请先选择父级ID', trigger: 'blur', type: 'number' }],
        menuName: [{ required: true, message: '规则名称不能为空', trigger: 'blur' }],
        menuType: [{ required: true, message: '菜单类型不能为空', trigger: 'blur' }],
        component: [{ required: true, message: '组件路径', trigger: 'blur' }],
        perms: [{ required: true, message: '按钮路径', trigger: 'blur' }],
        // remark: [{ required: true, message: '备注不可为空', trigger: 'blur' }],
      }
      return formRules
    },
  },
  created() {
    let query = this.$route.query
    this.loadPidTree()
    this.action = query.action
    if (query.action === 'add') {
      // 添加初始化
      this.forms.parentId = query.parentId || ''
      this.parentId = query.parentId || ''
      this.stitle = query.stitle || ''
    } else if (query.action === 'edit') {
      this.kv = query.kv
      this.initData()
    } else {
      $utils.toast.error('请求方式异常')
    }
  },
  methods: {
    initData() {
      let id = this.kv
      $utils.api.load(`/admin/system/menu/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data
          this.forms.status = Number(res.data.status) || 0
          this.forms.visible = Number(res.data.visible) || 0
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.forms.tag = this.forms.url
          this.forms.title = this.forms.name
          $form.handleSubmit(this)
        }
      })
    },
    pidChange(val) {
      // 获取最后一个id
      this.forms.parentId = val[val.length - 1]
    },
    loadPidTree() {
      let q = {}
      q.parentId = 0
      $utils.api.load('/admin/system/menu/list', q).then((res) => {
        let ll = res.data || []
        let x = []
        this.rule_arr = []
        let newArr = []
        const menu = { menuId: 0, menuName: '主类目', children: [] }
        menu.children = this.handleTree(ll, 'menuId')
        newArr.push(menu)
        for (let i = 0; i < newArr.length; i++) {
          const v = newArr[i]
          let c = {}
          c.value = v.menuId
          c.label = v.menuName
          c.children = []
          if (v.children) {
            let xx = []
            for (let ii = 0; ii < v.children.length; ii++) {
              const vv = v.children[ii]
              let cc = {}
              cc.value = vv.menuId
              cc.label = vv.menuName
              cc.children = []
              if (vv.children) {
                let xxx = []
                for (let iii = 0; iii < vv.children.length; iii++) {
                  const vvv = vv.children[iii]
                  let ccc = {}
                  ccc.value = vvv.menuId
                  ccc.label = vvv.menuName
                  ccc.children = []
                  if (vvv.children) {
                    let xxxx = []
                    for (let iiii = 0; iiii < vvv.children.length; iiii++) {
                      const vvvv = vvv.children[iiii]
                      let cccc = {}
                      cccc.value = vvvv.menuId
                      cccc.label = vvvv.menuName
                      cccc.children = []
                      xxxx.push(cccc)
                    }
                    ccc.children = xxxx
                  }
                  xxx.push(ccc)
                }
                cc.children = xxx
              }
              xx.push(cc)
            }
            c.children = xx
          }
          x.push(c)
        }
        this.rule_arr = x || []
      })
    },
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children',
      }

      var childrenListMap = {}
      var nodeIds = {}
      var tree = []

      for (let d of data) {
        let parentId = d[config.parentId]
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = []
        }
        nodeIds[d[config.id]] = d
        childrenListMap[parentId].push(d)
      }

      for (let d of data) {
        let parentId = d[config.parentId]
        if (nodeIds[parentId] == null) {
          tree.push(d)
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t)
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]]
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c)
          }
        }
      }
      return tree
    },
  },
}
</script>
<style lang="less" scoped></style>
